import React, { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import { phoneError, whatsAppLink } from "../utils/phone";

const API = process.env.REACT_APP_BACKEND_URL;
let businessNamePromise = null;
const getBusinessName = () => {
  if (!businessNamePromise) {
    businessNamePromise = axios
      .get(`${API}/api/content/contact_info`)
      .then((r) => r.data?.business_name || "Auvergne Tech Racing")
      .catch(() => "Auvergne Tech Racing");
  }
  return businessNamePromise;
};

export const buildReadyMessage = (apt, businessName) => {
  const first = (apt.client_name || "").trim().split(/\s+/)[0] || "";
  const plate = (apt.client_plate || "").trim();
  return `Bonjour${first ? ` ${first}` : ""}, votre véhicule ${plate ? `${plate} ` : ""}est prêt, vous pouvez venir le récupérer. — ${businessName}`;
};

export default function WhatsAppReadyButton({ apt, testId }) {
  const [businessName, setBusinessName] = useState("Auvergne Tech Racing");
  useEffect(() => { getBusinessName().then(setBusinessName); }, []);
  if (!apt?.client_phone || phoneError(apt.client_phone)) return null;
  return (
    <a
      href={whatsAppLink(apt.client_phone, buildReadyMessage(apt, businessName))}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      title="Prévenir le client que son véhicule est prêt"
      onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center gap-1 bg-[#25D366]/15 hover:bg-[#25D366]/25 text-[#25D366] border border-[#25D366]/30 px-1.5 py-0.5 rounded text-[10px] font-semibold transition-colors"
    >
      <MessageCircle size={10} /> WhatsApp
    </a>
  );
}
